import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ProductoService } from '@abm/producto/producto.service';
import { TipoVenta } from '@shared/enums/tipoVenta';
import { NgbCalendar, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatDate } from '@angular/common';
import { Precio } from '@shared/models/abm/Precio';
import { CondicionVenta } from '@shared/enums/condicionVenta';
import { TipoEstadoPrecio } from '@shared/enums/tipoEstadoPrecio';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { MessageService } from '@shell/message.service';
import { Moneda } from '@shared/models/abm/Moneda';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { AeroplantasService } from '@shared/aeroplantas.service';
import { TipoMoneda } from '@shared/enums/tipoMoneda';
import { ItemMultifiltroComponent } from '@shared/multifiltro/item-multifiltro/item-multifiltro.component';
import { ItemMultiFiltro } from '@shared/multifiltro/ItemMultifiltro';
import { TipoActivoPrecio } from '@shared/enums/tipoActivoPrecio';
import { PreciosService } from '../../precios.service';
import { ModalSubirExcelModificacionPreciosComponent } from '../modal-subir-excel-modificacion-precios/modal-subir-excel-modificacion-precios.component';

@Component({
  selector: 'app-actualizacion-precios',
  templateUrl: './actualizacion-precios.component.html',
  styleUrls: ['./actualizacion-precios.component.scss']
})
export class ActualizacionPreciosComponent implements OnInit {

  TipoUsuario = TipoUsuario;

  constructor(private productoService: ProductoService, private modalService: NgbModal,
    private messageService: MessageService,
    private http: HttpClient,
    private calendar: NgbCalendar,
    public authService: AuthService,
    private spinner: NgxSpinnerService,
    public aeroplantaService: AeroplantasService,
    private preciosService: PreciosService,
    private cdRef:ChangeDetectorRef) { }

  TEXTO_SIN_ELEMENTO = "-";

  tiposVentaMultiFiltro: ItemMultiFiltro[] = [];
  aeroplantasMultiFiltro: ItemMultiFiltro[] = [];
  lotesMultiFiltro: ItemMultiFiltro[] = [];
  codigosMultiFiltro: ItemMultiFiltro[] = [];
  productosMultiFiltro: ItemMultiFiltro[] = [];
  monedasMultiFiltro: ItemMultiFiltro[] = [];
  clientesMultiFiltro: ItemMultiFiltro[] = [];
  condicionesVentaMultiFiltro: ItemMultiFiltro[] = [];
  entregasMultiFiltro: ItemMultiFiltro[] = [];
  areasMultiFiltro: ItemMultiFiltro[] = [];
  segmentosMultiFiltro: ItemMultiFiltro[] = [];

  vigencias = [
    { nombre: "Vigentes", seleccionado: true },
    { nombre: "Vencidos", seleccionado: false },
    { nombre: "Futuros", seleccionado: false }
  ];
  estados = [
    { nombre: "Pendiente", seleccionado: false },
    { nombre: "Aprobado", seleccionado: true },
    { nombre: "Rechazado", seleccionado: false }
  ];

  niveles: any[] = [
    { id: "1", nombre: "1 - Producto/Vigencia/Moneda/Aeroplanta/Area de Negocio/Segmento/Cliente/Tipo operación/Direccion de entrega", seleccionado: true },
    { id: "2", nombre: "2 - Producto/Vigencia/Moneda/Aeroplanta/Area de Negocio/Segmento/Cliente/Tipo operación" },
    { id: "3", nombre: "3 - Producto/Vigencia/Moneda/Aeroplanta/Area de Negocio/Segmento/Cliente" },
    { id: "4", nombre: "4 - Producto/Vigencia/Moneda/Aeroplanta/Area de Negocio/Segmento" },
    { id: "5", nombre: "5 - Producto/Vigencia/Moneda/Aeroplanta/Area de Negocio" },
    { id: "6", nombre: "6 - Producto/Vigencia/Moneda/Aeroplanta" },
  ];


  TipoActivoPrecio = TipoActivoPrecio;
  enumCondicionVenta = CondicionVenta;
  enumEstadoPrecio = TipoEstadoPrecio;
  errorEnExportacion: boolean = false;

  tipoVenta: TipoVenta;
  moneda: Moneda;
  preciosFiltradosMultifiltro: Precio[];
  preciosFiltrados: Precio[];
  listaPrecios: Precio[];
  esperandoCarga: boolean = false;
  messagePrecios: string = "C a r g a n d o . . ."
  procesandoFiltros:boolean = false;

  modelFecha: NgbDateStruct;
  modelHora: any;

  cantPrecios: number = 0;

  //hooks

  ngOnInit() {
    this.getPrecios();

    this.modelFecha = this.calendar.getToday();

    const horaActual = new Date();
    this.modelHora = { hour: horaActual.getHours(), minute: horaActual.getMinutes(), second: horaActual.getSeconds() }
  }

  filtrarPreciosMulti() {
    if (this.preciosFiltrados != null) {

      this.procesandoFiltros = true;

      this.preciosFiltradosMultifiltro = this.preciosFiltrados.filter(p => {
        let mostrar = true;

        if (this.tiposVentaMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.tiposVentaMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => Number(elementoAux.id) == p.tipoVenta)
          );
        }

        if (this.aeroplantasMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.aeroplantasMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == p.codigoAeroplanta)
          );
        }

        if (this.lotesMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.lotesMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == p.numeroLote)
          );
        }

        if (this.codigosMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.codigosMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == p.producto.codigoProducto)
          );
        }

        if (this.productosMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.productosMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == p.producto.nombreProducto)
          );
        }

        if (this.monedasMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.monedasMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == p.moneda.nombre)
          );
        }

        if (this.clientesMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.clientesMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => p.cliente != null ? elementoAux.id == p.cliente.razonSocial : elementoAux.id == ItemMultifiltroComponent.SIMBOLO_VALOR_NULO)
          );
        }

        if (this.condicionesVentaMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.condicionesVentaMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => Number(elementoAux.id) == p.condicionVenta)
          );
        }

        if (this.entregasMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.entregasMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == (p.direccionEntrega != null ? p.direccionEntrega : ItemMultifiltroComponent.SIMBOLO_VALOR_NULO))
          );
        }

        if (this.areasMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.areasMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == (p.areaNegocio != null ? p.areaNegocio.nombreArea : ItemMultifiltroComponent.SIMBOLO_VALOR_NULO))
          );
        }

        if (this.segmentosMultiFiltro.some(elemento => elemento.seleccionado)) {
          mostrar = mostrar && (
            this.segmentosMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == (p.segmento != null ? p.segmento.nombreSegmento : ItemMultifiltroComponent.SIMBOLO_VALOR_NULO))
          );
        }

        return mostrar;

      });

      this.procesandoFiltros = false;
    }
  }

  cargarListasFiltrosMulti() {
    this.filtrarPreciosMulti();
  }

  getDescripcionTipoVenta(tipoVenta: TipoVenta) {
    if (tipoVenta == TipoVenta.cabotaje) {
      return "Cabotaje";
    } else if (tipoVenta == TipoVenta.internacional) {
      return "Internacional";
    } else {
      return "Sin tipo venta.";
    }
  }

  getDescripcionCondicionVenta(condicionVenta: CondicionVenta) {
    if (condicionVenta == CondicionVenta.contado) {
      return "CONTADO";
    } else if (condicionVenta == CondicionVenta.cuentaCorriente) {
      return "CTA CTE";
    } else {
      return "Sin condición venta.";
    }
  }

  getDescripcionEntregas(entrega: number) {
    return entrega;
    /*
    if(entrega == CondicionVenta.contado){
      return "CONTADO";
    }else if(entrega == CondicionVenta.cuentaCorriente){
      return "CTA CTE";
    }else{
      return "Indeterminado";
    }
    */
  }

  getPrecios() {
    this.cantPrecios = 0;
    this.esperandoCarga = true;
    this.spinner.show('spinnerGrafico');
    this.productoService.getPrecios()
      .subscribe(result => {
        this.cantPrecios = result.length;

        result.forEach(p => {

          if (p.aprobadoUserName && p.aprobadoUserName.indexOf(',') > -1) p.aprobadoUserName = JSON.parse(p.aprobadoUserName.replace(/'/g, '"')).nombresCompletos;

          if (p.importoUserName && p.importoUserName.indexOf(',') > -1) p.importoUserName = JSON.parse(p.importoUserName.replace(/'/g, '"')).nombresCompletos;
        });

        this.preciosFiltrados = result;
        this.listaPrecios = result;
        this.filtrarPrecios(null);
        this.spinner.hide('spinnerGrafico');
        this.esperandoCarga = false;

        this.cargarListasFiltrosMulti();
      })
  }

  // form

  keysTipoVenta() {
    const keys = Object.keys(this.tipoVenta);
    keys.shift();
    return keys.slice(keys.length / 2);
  }

  onRefreshClick() {
    this.getPrecios();
  }



  recargarForm() {
    this.ngOnInit();
  }

  obtenerListaIdsFiltrados() {
    return this.preciosFiltrados.map(p => p.id);
  }

  seleccionDeNivelesValida(event){    
    
    this.cdRef.detectChanges();
  
    if ( ! this.niveles.some(e => e.seleccionado) ) { // Si no quedo ningun nivel seleccionado
      // Vuelvo a seleccionar el tildado. Selecion invalida.
      event.seleccionado = true;
      return false;
    }

    if( this.niveles.filter(e => e.seleccionado).length > 1){ // Si hay mas de un nivel seleccionado
      // Dejo seleccionado el tildado y destildo el anterior. Seleccion valida.
      this.niveles.forEach(n => n.seleccionado = false);
      event.seleccionado = true;
      return true;
    }

    return true; // No deberia llegar aca
  }

  filtrarPrecios(event) {
    if( event != null && ! this.seleccionDeNivelesValida(event) ){
      this.messageService.showErrorMessage("Debe haber un nivel seleccionado obligatoriamente.");
      return;
    }

    if (this.vigencias != null && this.preciosFiltrados != null) {
      this.procesandoFiltros = true;

      this.preciosFiltrados = this.listaPrecios.filter(a => {
        let agregar = true;

        if (this.vigencias.some(e => e.seleccionado)) {

          const fechaHora = this.formatDate(this.modelFecha.year, this.modelFecha.month, this.modelFecha.day, this.modelHora.hour, this.modelHora.minute);

          agregar = agregar && (
            (this.vigencias[0].seleccionado == true
              && formatDate(a.fechaHasta, 'yyyy/MM/dd', 'en') >= formatDate(fechaHora, 'yyyy/MM/dd', 'en') && formatDate(a.fechaDesde, 'yyyy/MM/dd', 'en') <= formatDate(fechaHora, 'yyyy/MM/dd', 'en'))
            ||
            (this.vigencias[1].seleccionado == true
              && formatDate(a.fechaHasta, 'yyyy/MM/dd', 'en') < formatDate(fechaHora, 'yyyy/MM/dd', 'en')
            )
            ||
            (this.vigencias[2].seleccionado == true
              && formatDate(a.fechaDesde, 'yyyy/MM/dd', 'en') > formatDate(fechaHora, 'yyyy/MM/dd', 'en')
            )

          )
        }

        if (this.estados.some(e => e.seleccionado)) {
          agregar = agregar && (
            (this.estados[0].seleccionado == true
              && (a.estadoPrecio == TipoEstadoPrecio.Pendiente || a.estadoPrecio == TipoEstadoPrecio.AprobadoRetroactivo))
            ||
            (this.estados[1].seleccionado == true
              && a.estadoPrecio == TipoEstadoPrecio.Aprobado)
            ||
            (this.estados[2].seleccionado == true
              && a.estadoPrecio == TipoEstadoPrecio.Rechazado)
          );
        }

        if (this.niveles.some(e => e.seleccionado)) {
          agregar = agregar && (
            (this.niveles[0].seleccionado == true && a.nivelPrecio == 1)
            ||
            (this.niveles[1].seleccionado == true && a.nivelPrecio == 2)
            ||
            (this.niveles[2].seleccionado == true && a.nivelPrecio == 3)
            ||
            (this.niveles[3].seleccionado == true && a.nivelPrecio == 4)
            ||
            (this.niveles[4].seleccionado == true && a.nivelPrecio == 5)
            ||
            (this.niveles[5].seleccionado == true && a.nivelPrecio == 6)

          );
        }

        return agregar;
      });

      this.procesandoFiltros = false;
      this.cargarListasFiltrosMulti();
    }
  }

  formatDate(year, month, day, hour, minute): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':00';
  }

  obtenerDescripcionMoneda(moneda: Moneda){
    if(moneda.tipoMoneda == TipoMoneda.PES){
      return "ARP";      
    }else{
      return moneda.nombre;
    }
  }

  recargarLotes(items: ItemMultiFiltro[]){
    this.lotesMultiFiltro = items;
    this.filtrarPreciosMulti();
  }

  recargarCodigos(items: ItemMultiFiltro[]){
    this.codigosMultiFiltro = items;
    this.filtrarPreciosMulti();
  }

  recargarProductos(items: ItemMultiFiltro[]){
    this.productosMultiFiltro = items;
    this.filtrarPreciosMulti();
  }

  recargarMonedas(items: ItemMultiFiltro[]){
    this.monedasMultiFiltro = items;
    this.filtrarPreciosMulti();
  }

  recargarClientes(items: ItemMultiFiltro[]){
    this.clientesMultiFiltro = items;
    this.filtrarPreciosMulti();
  }

  recargarTiposVenta(items: ItemMultiFiltro[]){
    this.tiposVentaMultiFiltro = items;
    this.filtrarPreciosMulti();
  }

  recargarEntregas(items: ItemMultiFiltro[]){
    this.entregasMultiFiltro = items;
    this.filtrarPreciosMulti();
  }

  recargarAreas(items: ItemMultiFiltro[]){
    this.areasMultiFiltro = items;
    this.filtrarPreciosMulti();
  }

  recargarSegmentos(items: ItemMultiFiltro[]){
    this.segmentosMultiFiltro = items;
    this.filtrarPreciosMulti();
  }

  recargarAeroplantas(items: ItemMultiFiltro[]){
    this.aeroplantasMultiFiltro = items;
    this.filtrarPreciosMulti();
  }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

  descargarExcel() {
    this.errorEnExportacion = false;

    const listaIds = this.preciosFiltradosMultifiltro.map(p => p.id);

    if (listaIds.length == 0) {
      this.messageService.showErrorMessage("No hay precios filtrados para descargar.");
      return;
    }

    this.productoService.descargarExcelActualizacionPrecios(listaIds)
      .subscribe((res: Blob) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
        saveAs(blob, "ListadoDePrecios");
      }, () => {
        this.errorEnExportacion = true;
      });
  }

  importarPrecios(){
    const modalRef = this.modalService.open(ModalSubirExcelModificacionPreciosComponent, { centered: true, size: "lg", backdrop: "static" }); 
    
    modalRef.result.then(result => {
      if (result == true) {
        this.ngOnInit();
      }
    });
  }

  getDescripcionAeroplantas(codigoAeroplanta: string) {
    try{
      return this.aeroplantaService.obtenerDescripcionAeroplantaPrecios(codigoAeroplanta);
    }catch(Ex){
      return ".";
    }    
  }
}


